import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import {
  getAdminAccessToken,
  getStoreAccessToken,
  getStoreId,
} from "../../utils/auth";
import { Order } from "../../types/modules/order.type";
import { OrderDetails } from "../../types/modules/orderDetail.type";

interface UseOrdersParams {
  page?: number;
  limit?: number;
  name?: string;
  status?: string;
  storeId?: number;
}

export const useStoreOrders = ({
  page = 1,
  limit = 10,
  name = "",
  status = "",
  storeId,
}: UseOrdersParams) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    name: name?.toString(),
    status: status?.toString(),
  });

  if (storeId) {
    queryParams.append("storeId", storeId.toString());
  }

  const storeIdToSend = storeId ? storeId : getStoreId();
  const token = storeId ? getAdminAccessToken() : getStoreAccessToken();

  return useQuery({
    queryKey: ["store-orders", page, limit, name, storeIdToSend, status, token],
    queryFn: () =>
      fetcher<{ orders: Order[]; totalItems: number; totalPages: number }>(
        `order/byStore?${queryParams.toString()}`,
        token
      ),
  });
};

export const useSingleOrderDetail = (
  orderId: number | null,
  storeId?: number
) => {
  const endPoint = storeId
    ? `order/${orderId}/byStore?storeId=${storeId}`
    : `order/${orderId}/byStore`;
  const token = storeId ? getAdminAccessToken() : getStoreAccessToken();
  return useQuery({
    queryKey: ["order-detail", orderId, storeId, token],
    queryFn: () => fetcher<OrderDetails>(endPoint, token),
    enabled: !!orderId,
  });
};
